import { supabase } from "../lib/supabase";

// Module-level cache: the curated platform list rarely changes, and
// BillingMethodSection may re-mount within a session — without this,
// re-opening it hits the DB again for identical data. Caching the in-flight
// promise (not just the resolved value) also collapses concurrent callers
// into a single round-trip.
//
// Source: DISTINCT platform_name from affiliate_exports.export_templates —
// the affiliate conversions exporter's own template catalog is now the
// single source of truth for platform names (DEV-2036 follow-up,
// 2026-08-26). Previously this queried a legacy `affiliate-platforms` Edge
// Function backed by a Neon/Replit Postgres (Connor's now-decommissioned
// "Athena Data Exchange" app) — that function, its Neon DB secret, and this
// service's dependency on it are removed as part of the same change. All
// (not just active) templates are included: support may want to record a
// billing method for a platform that isn't currently offered for self-serve
// export.
let cachedPlatformsPromise = null;

export async function fetchAffiliatePlatforms() {
  if (!supabase) return [];
  if (!cachedPlatformsPromise) {
    cachedPlatformsPromise = supabase
      .schema("affiliate_exports")
      .from("export_templates")
      .select("platform_name")
      .order("platform_name", { ascending: true })
      .then(({ data, error }) => {
        if (error) throw error;
        return [...new Set((data ?? []).map((row) => row.platform_name))];
      })
      .catch((err) => {
        cachedPlatformsPromise = null; // don't cache failures — let the next call retry
        throw err;
      });
  }
  return cachedPlatformsPromise;
}

// Test-only escape hatch — the module-level cache persists across test
// cases within the same file unless explicitly cleared.
export function __resetAffiliatePlatformsCacheForTests() {
  cachedPlatformsPromise = null;
}
